export default "__VITE_ASSET__Bk12cAOT__"